import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-dialogue',
  imports: [MatDialogModule,CommonModule],
  templateUrl: './warning-dialogue.component.html',
  styleUrl: './warning-dialogue.component.scss'
})
export class WarningDialogueComponent {
  constructor(
    public dialogRef: MatDialogRef<WarningDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { productIds: string[] }
  ) {}
}
